import { CleaveOptions } from 'cleave.js/options';
import { Field } from 'formik';
import React, { Component } from 'react';
import { Nullable } from '../../Shared/Types';
import { AutoCompleteTypes, MaskedTextField } from '../MaskedTextField';
import { getErrorText } from './getErrorText';

type TextFieldProps = {
    name: string;
    testId: string;
    label?: Nullable<string>;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    helperText?: React.ReactNode;
    autoFocus?: boolean;
    multiline?: boolean;
    placeholder?: string;
    rowsMax?: number;
    maxLength?: number;
    warningText?: string;
    startAdornment?: React.ReactNode;
    hideCharacterLimit?: boolean;
    autoCompleteType?: AutoCompleteTypes;
    formatOptions?: CleaveOptions;
    shrinkLabel?: boolean;
    hideWarningEmptyHelperText?: boolean;
    error?: string;
    secondaryHelperText?: string;
    showHelperTextOnReadyOnly?: boolean;
    mask?: string;                
    maskChar?: string;           
    alwaysShowMask?: boolean;      
    onFocus?(): void; 
    onBlur?(value: string): void;
    filterFunction?(value: string): string;
    formatFunction?(value: string): string;
    unformatFunction?(value: string): string;
    onClear?(): void;
    onChange?(value: string, event?: React.ChangeEvent<HTMLInputElement>): void;
    type?: React.InputHTMLAttributes<HTMLInputElement>['type'];
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
};

export class FormikTextField extends Component<TextFieldProps> {
    public render() {
        return <Field name={this.props.name}>{this.renderFormikTextField}</Field>;
    }

    private renderFormikTextField = ({ field, form }: any) => {
        const errorText = getErrorText(form, field.name);
        const onClear = () => {
            form.setFieldValue(field.name, '');
            form.setFieldTouched(field.name, true, false);

            if (this.props.onClear) this.props.onClear();
        };

        const onBlur = () => {
            form.setFieldTouched(field.name, true, false);
            this.props.onBlur?.(field.value || '');
        };

        const onChange = (value: string, event?: React.ChangeEvent<HTMLInputElement>) => {
            form.setFieldValue(field.name, value);
            form.setFieldTouched(field.name, true, false);

            if (this.props.onChange) this.props.onChange(value, event);
        };

        const onFocus = () => {
            if (this.props.readOnly) return;
            if (this.props.disabled) return;
            this.props.onFocus?.();
        };

        return (
            <MaskedTextField
                {...this.props}
                value={field.value || ''}
                name={field.name}
                fullWidth
                onChange={onChange}
                onBlur={onBlur}   
                onFocus={onFocus}
                onClear={onClear}
                shrinkLabel={this.props.shrinkLabel && !!field.value}
                errorText={errorText ? errorText : this.props.error ? this.props.error : ''}
                secondaryHelperText={this.props.secondaryHelperText}
                showHelperTextOnReadOnly={this.props.showHelperTextOnReadyOnly}
            />
        );
    };
}
